module.exports = __webpack_public_path__ + "media/bootstrap-icons/mic-mute-fill-e7bd9acb.svg";